require('./angular');
module.exports = angular;



/*****************
 ** WEBPACK FOOTER
 ** ./DeliveryCreate/UI/~/angular/index.js
 ** module id = 12
 ** module chunks = 0
 **/